import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import type { CustomerDetailsType } from '@customTypes/customer';
import api from '@services/api';

const useGetCustomer = () => {
  const { id } = useParams();

  const [customer, setCustomer] = useState<CustomerDetailsType | null>(null);
  const [loading, setLoading] = useState(true);

  const getCustomer = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`/customer/${id}`);
      setCustomer(response.data);
    } catch {
      toast.error('Erro ao carregar os detalhes do cliente. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getCustomer();
    }
  }, [getCustomer, id]);

  return {
    customer,
    loading,
  };
};

export default useGetCustomer;
